import { persistStore, persistReducer, createTransform } from "redux-persist";
import rootReducer from "./reducers";
import storage from "redux-persist/lib/storage/session";
import { configureStore } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";
import { CONFIG } from "../environment";

const encrypt = createTransform(
  (inboundState, key) => {
    if (!inboundState) return inboundState;
    const cryptedText = CryptoJS.AES.encrypt(
      JSON.stringify(inboundState),
      CONFIG.ENCRYPT_KEY
    );

    return cryptedText.toString();
  },
  (outboundState, key) => {
    if (!outboundState) return outboundState;
    const bytes = CryptoJS.AES.decrypt(outboundState, CONFIG.ENCRYPT_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  }
);

const rootPersistConfig = {
  key: "root",
  storage,
  version: 1,
  whitelist: ["auth", "app"],
  //blacklist: ['auth','app'],
  transforms: [encrypt],
};

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

const persister = persistStore(store);

export { store, persister };
